export const AYA_GUID = 'ed4f2919-bdc7-eb11-aa56-bc7afbf6c942';
